import { toast } from 'react-toastify'
import { get, uniqBy } from 'lodash'
import moment from 'moment'

export const getVideoThumbnail = (cloudfrontDomain, asset_id) => {
  // const accountId = localStorage.getItem('accountId')
  return `${cloudfrontDomain}/public/images/thumbnails/${asset_id}/thumbnail.png`
}

export const getThumbnail = (cloudfrontDomain, s3Key) => {
  return `${cloudfrontDomain}/${s3Key}`
}

export const formatFileName = (fileName) => {
  const extension = fileName.split('.').pop()
  const extRemoved = fileName.replace(`.${extension}`, '')
  return `${extRemoved.replace(/[^A-Z0-9]+/gi, '_')}${Date.now()}.${extension}`.toLowerCase()
}

export const masterAndChildIntersection = (masterData = [], childData = []) => {
  return uniqBy(masterData, (obj) => obj?._id).filter((masterObj) =>
    childData.find((obj) => masterObj?._id === obj?._id),
  )
}

export function viewsFormatter(num) {
  if (Math.abs(num) < 1000) return Math.sign(num) * Math.abs(num)
  if (Math.abs(num) < 1000000) return Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'K'

  return Math.sign(num) * (Math.abs(num) / 1000000).toFixed(1) + 'M'
}

export const convertDuration = (seconds) => {
  if (seconds !== undefined) {
    seconds = parseInt(seconds)
    let minutes = parseInt(seconds / 60)
    if (seconds > 3600) {
      return Math.floor(minutes / 60) + 'h:' + (minutes % 60) + 'm'
    } else if (seconds > 60) {
      return Math.floor(seconds / 60) + 'm:' + (seconds % 60) + 's'
    } else {
      return seconds + 's'
    }
  } else {
    return 'N/A'
  }
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const getImageCropObj = (actualWidth, actualHeight, width, height) => {
  const aspectRatio = actualWidth / actualHeight
  const outputImageAspectRatio = width / height
  if (actualWidth < width || actualHeight < height) {
    let outputWidth = actualWidth
    let outputHeight = actualHeight
    if (aspectRatio > outputImageAspectRatio) {
      outputWidth = actualHeight * outputImageAspectRatio
    } else if (aspectRatio < outputImageAspectRatio) {
      outputHeight = actualWidth / outputImageAspectRatio
    }
    return { x: 0, y: 0, width: outputWidth, height: outputHeight, aspect: outputImageAspectRatio }
  }
  let outputWidth = width
  let outputHeight = height
  if (aspectRatio > outputImageAspectRatio) {
    outputWidth = height * outputImageAspectRatio
  } else if (aspectRatio < outputImageAspectRatio) {
    outputHeight = width / outputImageAspectRatio
  }
  return { x: 0, y: 0, width: outputWidth, height: outputHeight, aspect: outputImageAspectRatio }
}

export function raiseToast(type, message) {
  if (type === 'success') {
    toast.success(message, {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    })
  } else if (type === 'error') {
    toast.error(message, {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    })
  } else if (type === 'warn') {
    toast.warn(message, {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    })
  } else if (type === 'info') {
    toast.info(message, {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    })
  }
}

export function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  )
}

export function activeArray(arr) {
  return arr.filter((ele) => {
    return (
      ele.status === true &&
      (ele.hasOwnProperty('delete_marker') ? ele.delete_marker === false : true)
    )
  })
}

export const checkPermissions = (permissions, permToCheck) => {
  let isAllowed = false
  if (permToCheck) {
    if (typeof permToCheck === 'string') {
      isAllowed |= get(permissions, permToCheck)
    } else {
      permToCheck.forEach((perm) => {
        isAllowed |= get(permissions, perm)
      })
    }
  }
  return isAllowed
}

export const checkModuleAllowed = (moduleName, accountPermissions) => {
  if (accountPermissions && moduleName in accountPermissions) {
    return accountPermissions[moduleName]
  }
  return true
}

export const calStepSize = (min, max, steps = 4) => {
  let oMin = min
  let oMax = max
  let desiredSteps = steps
  let range = max - min
  //find magnitude and steps in powers of 10
  let step = range / steps

  let mag10 = Math.ceil(Math.log(step) / Math.log(10))
  let baseStepSize = Math.pow(10, mag10)

  //find common divisions to get closer to desiredSteps
  let trySteps = [5, 4, 2, 1]
  for (let i = 0; i < trySteps.length; ++i) {
    let stepSize = Number(baseStepSize / trySteps[i])
    let ns = Math.round(range / stepSize)
    //bail if anything didn't work, We can't check float.ZeroTolernace anywhere since we should
    //work on arbitrary range values

    if (isNaN(baseStepSize) || isNaN(ns) || ns < 1) return

    min = Math.floor(oMin / stepSize) * stepSize
    max = Math.ceil(oMax / stepSize) * stepSize
    steps = Math.round((max - min) / stepSize)

    if (steps <= desiredSteps) return stepSize
  }
}

export function validURL(str) {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?',
    'i',
  ) // fragment locator
  console.log('!!pattern.test(str)', !!pattern.test(str))
  return !!pattern.test(str)
}

export function validateLink(linkObj) {
  let validObj = { isValid: true, error: '' }

  if (linkObj.type.trim().length === 0) {
    validObj.isValid = false
    validObj.error = 'Link Cannot be Empty!'
  }

  if (linkObj.type === 'EXTERNAL') {
    validObj.isValid = validURL(linkObj.data?.url)
    validObj.error = validObj.isValid ? '' : 'Enter a Valid Link!'
  }
  if (
    linkObj.type === 'CONTENT_DETAIL' ||
    linkObj.type === 'ARTIST_DETAIL' ||
    linkObj.type === 'VENUE_DETAIL' ||
    linkObj.type === 'CATEGORY' ||
    linkObj.type === 'PAGES' ||
    linkObj.type === 'IPTV' ||
    linkObj.type === 'CONTENT_DETAIL_PLAYER' ||
    linkObj.type === 'PLAYER'
  ) {
    validObj.isValid = !isEmpty(linkObj.data)
    validObj.error = validObj.isValid ? '' : 'Enter a Valid Link!'
  }

  return validObj
}

export function convertToNormalDate(str) {
  var date = new Date(str),
    mnth = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2)
  return [day, mnth, date.getFullYear()].join('/')
}

export const concatDateTimeToIso = (date, time) => {
  return moment(convertToNormalDate(date) + ' ' + time, 'DD/MM/YYYY HH:mm').toISOString()
}

export const createSlug = (name = '') => {
  return name.toLowerCase().replace(/[^A-Z0-9]+/gi, '-')
}

export const getImage = (cfDomainUrl, s3Key) => {
  return cfDomainUrl + '/' + s3Key
}

export const createPageUrl = (domainUrl, pageUrl, pageType = '/custom') => {
  return domainUrl + pageType + pageUrl
}
export const getMonthDates = (currentDate, year, month) => {
  let monthDate = moment(year + '-' + month, 'YYYY-MM')
  let daysInMonth = monthDate.daysInMonth()
  let monthEnd = moment(currentDate).endOf('month')
  let arrDays = []
  for (let i = 0; i < daysInMonth; i++) {
    arrDays.push(moment(monthEnd).subtract(i, 'days').format('D MMM yyyy'))
  }
  return arrDays.reverse()
}

export const convertToLocalTime = (date) => {
  if (!date) return ''

  return new Date(date + 'Z').toLocaleTimeString('en-UK', {
    timeStyle: 'short',
    hour12: false,
  })
}
